export const ERRORS_MODULE_NAME = "errors";
